exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".FabButton-module__fab__2KyUm {\r\n\tposition: fixed !important;\r\n\tbottom: 1em;\r\n\tright: 1em;\r\n\tz-index: 1100;\r\n}\r\n", "",{"version":3,"sources":["C:\\Users\\andrew\\IdeaProjects\\cmu\\moni2\\src\\components\\controlls\\Fab\\FabButton.module.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,WAAW;CACX,UAAU;CACV,aAAa;AACd","file":"FabButton.module.css","sourcesContent":[".fab {\r\n\tposition: fixed !important;\r\n\tbottom: 1em;\r\n\tright: 1em;\r\n\tz-index: 1100;\r\n}\r\n"]}]);

// Exports
exports.locals = {
	"fab": "FabButton-module__fab__2KyUm"
};